import { VoiceId } from './fetchSpeechSynthesisTask';

type CreateSpeechSynthesisTaskParams = {
  webEpisodeId: string;
  voiceId: VoiceId;
  isNeural?: boolean;
  style?: 'conversational' | 'news';
};

export type CreateSpeechSynthesisTaskResponse = { status: number };

export async function createSpeechSynthesisTask({
  webEpisodeId,
  voiceId,
  isNeural,
  style,
}: CreateSpeechSynthesisTaskParams): Promise<
  CreateSpeechSynthesisTaskResponse
> {
  try {
    const response = await fetch(
      `/api/proxy/v3/episode/webEpisodeId:${webEpisodeId}/speech_synthesis_task`,
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify({
          voiceId,
          isNeural,
          style,
        }),
      }
    );
    if (response.ok) {
      return response;
    }
    throw new Error(
      `Unable to create speech synthesis task for episode: ${webEpisodeId}`
    );
  } catch (err) {
    throw new Error(err.message);
  }
}
